var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("circle " + _vm.status_class),attrs:{"title":_vm.status_title + (_vm.version ? (" (v" + _vm.version + ")") : '')}})}
var staticRenderFns = []

export { render, staticRenderFns }